import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Home.module.css";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className={styles.homeWrapper}>

      {/* HERO SECTION */}
      <div className={styles.homeContainer}>

        <div className={styles.homeTextBlock}>
          <h1 className={styles.heroTitle}>Welcome to Heirio</h1>

          <p className={styles.homeText}>
            I'm your Personal Vault, here to help you preserve the precious information, wisdom,
            and documents that make you unique. Let's create something beautiful together.
          </p>

          <p className={styles.homeText}>
            We will deliver the information into the right hands that you select. Just relax and trust us.
          </p>
        </div>

        <div className={styles.homeButtons}>
          <button onClick={() => navigate("/signup")}>Sign Up</button>
          <button onClick={() => navigate("/login")}>Login</button>
        </div>
      </div>

      {/* SCROLL SECTION */}
      <section className={styles.infoSection}>
        <h2 className={styles.infoTitle}>Your Legacy, Preserved Forever</h2>
        <p className={styles.infoSubtext}>
          Heirio ensures your memories, documents, and wisdom reach the people you choose.
        </p>

        <div className={styles.infoCards}>
          <div className={styles.infoCard}>
            <h3>Secure Storage</h3>
            <p>Your data is encrypted and stored safely.</p>
          </div>

          <div className={styles.infoCard}>
            <h3>Smart Delivery</h3>
            <p>We deliver your information only to trusted recipients.</p>
          </div>

          <div className={styles.infoCard}>
            <h3>Future-Proof</h3>
            <p>Your legacy stays protected for generations.</p>
          </div>
        </div>
      </section>

      {/* MORE SECTION */}
      <section className={styles.moreSection}>
        <h2 className={styles.moreTitle}>Why Choose Heirio?</h2>
        <p className={styles.moreSubtext}>
          A modern solution for preserving what truly matters.
        </p>

        <ul className={styles.moreList}>
          <li>✔ Easy to use</li>
          <li>✔ Built for families</li>
          <li>✔ Designed for long-term preservation</li>
        </ul>
      </section>

    </div>
  );
}
